import {
  gaInfo,
  apiUrl,
  webActivityUrl,
  redirectUrl,
  fbAppId,
  rewardConfigPid,
  gaAction,
  lozads,

} from "./config.js";
import {
  trackGA,
  pushStateUrl,
  apiBasicParams,
  apiLoginParams,
  msg,
  initGaEvent,
  getQueryString,
  initLozad,

} from "./util.js";
// ${Efun.inviteType ? '?inviteId=${Efun.inviteType}':''}
$(function () {
  Efun.shareKey = "";
  Efun.cookieFlag = ""; //必须
  Efun.inviteId = getQueryString("inviteId");
  Efun.inviteType = getQueryString("inviteType");

  Efun.gotoLogin = function () {
    if (Efun.inviteId) {
      Efun.loginUrl = webActivityUrl + 'success.html?inviteId=' + Efun.inviteId +
        '&inviteType=' + Efun.inviteType;
    } else {
      // Efun.loginUrl = webActivityUrl + 'success.html';
      Efun.loginUrl = webActivityUrl.replace("index.html", "") + 'success.html';
      console.log("Efun.loginUrl", Efun.loginUrl)
    }
    window.location.href = `https://m.efunen.com/enter/login?from=https://m.efunen.com/act-login-redirect.html?redirect=${encodeURIComponent(
            Efun.loginUrl
        )}&callLogin=fbLogin`

  };
  // 登录后的回调，不需要选服选角
  Efun.afterLogin = function () {};
  /* 登出，清除cookie */
  Efun.logout = function () {
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (var i = keys.length; i--;) {
        if (keys[i].indexOf("_") != 0) {
          /* 以_开头的google分析作标识用的cookie不删除 */
          delCookie(keys[i]);
        }
      }
    }
    if (Efun.inviteId) {
      window.location.href = "./index.html?inviteId=" + Efun.inviteId +
        '&inviteType=' + Efun.inviteType;

    } else {
      window.location.href = "./index.html";
    }
  };

  var business = {
    allRewardCode: [],
    totalOption: [], // 答题选项汇总
    msgList: ["神仙姐姐美若天仙", "降龙十八掌吃我一掌", "最强武侠，唯有天龙", "天龙八部，江湖百态", "降龙十八掌威力无畴", "有没有扫地僧", "乔峰一身正气，为人正派", "北乔峰，南慕容"], // 初始留言
    newMsgList: [], // 接口获取的留言
    swiperTime: 20000, // 轮播时间
    rewardList: ["1级精金x5", "1级玄铁x5", "初级铭刻符x3", "随机染料x1", "铜币x30000", "新马专属称号 刀光剑影x1"], // 兑换奖励名称
    rewardGAList: ["精金", "玄铁", "铭刻符", "染料", "铜币", "称号"], // 埋点奖励名称
    rewardIndex: -1, // 当前点击的奖励
    todayShareNum: -1, // 今日分享次数
    myInt: null, // 留言轮播定时器
    getRewardTimeIsNotStart: null, // 是否到达领奖时间
    getRewardRTimeIsEnd: null, // 是否到达领奖结束时间
    init() {
      initLozad(lozads);
      pushStateUrl("del", "#thankyou");
      business.getDeviceInfo();
      Efun.init();
      business.bindEvent();
      business.initMsg();
      initGaEvent(gaInfo);
      // business.getTotalPreNum();
      business.getActivityConfigFromGraphql();
      if (business.isLogin()) {
        business.afterLoginCallBack();
      }
    },
    afterLoginCallBack() {
      // $(".login").hide();
      // $(".logout").show();
      $(".login").css("opacity", "1")
      $(".login-user").html(Efun.userId);
      business.getActivityInfo();
      business.getRewardInfo();
      business.getRewardConfig();
    },
    bindEvent() {
      // 新的
      /* 登录 */
      $(".btn-login").click(function () {
        Efun.gotoLogin();
      });
      $(".btn-logout").click(function () {
        Efun.logout();
      });
      // 查询奖励
      $(".btn-record").click(function () {
        if (!business.isLogin(true)) return;
        business.getRewardInfo()
        $("#pop-div1").bPopup();
      });
      // 复制奖励
      $("#rewardTable").on('click', '.btn-copy', function () {
        let copyBtnId = $(this).attr("id");
        const state = $(this).prev().text(); // prev()方法返回被选元素的前一个同级元素
        business.copyBtn(copyBtnId);
      });
      // 一键领取
      $(".btn-get").click(function () {
        if (!business.getRewardTimeCheckState()) {
          return;
        }
        business.showPackageId()
      });
      // 活动规则
      $(".text-rule-1").click(function () {
        $("#pop-div2").bPopup();
      });
      $(".text-rule-2").click(function () {
        $("#pop-div3").bPopup();
      });
      $(".text-rule-3").click(function () {
        $("#pop-div4").bPopup();
      });
      // 留言
      $(".btn-msg").click(function () {
        if (!business.isLogin(true)) return;
        if ($(this).hasClass("disabled")) return;
        $("#pop-div5").bPopup();
      });
      $(".btn-confirm-msg").click(function () {
        business.leaveMsg()
      });
      // 兑换
      $(".btn-exchange").click(function () {
        if (!business.isLogin(true)) return;
        if ($(this).hasClass("disabled")) return;
        const index = $(this).parents(".reward").index()
        business.rewardIndex = index

        $("#reward-name").text(business.rewardList[index])
        $("#pop-div6").bPopup();
      });
      // 确认兑换
      $(".btn-confirm-reward").click(function () {
        trackGA(`点击${business.rewardGAList[business.rewardIndex]}弹窗确认按钮`, gaAction.click, `成功兑换${business.rewardGAList[business.rewardIndex]}用户`)
        business.getWuPointReward()
      });
      // 答题
      $(".btn-next").click(function () {
        if (!business.isLogin(true)) return;
        const index = $(this).parents(".question-box").index() // 当前问题
        const val = $("input[type='radio']:checked").eq(index - 1).val() // 当前下标
        business.totalOption.push(val)
        $(`.question-box${index}`).hide()
        $(`.question-box${index+1}`).show()
      });
      $(".btn-finish").click(function () {
        const val = $("input[type='radio']:checked").eq(3).val()
        business.totalOption.push(val)
        business.answerQuestion()
      });
      // fb分享
      $(".fb-share").click(function () {
        if (!business.isLogin(true)) return;
        business.fbShare();
      });
    },
    getDeviceInfo() {
      if (DeviceInfo.isMb()) {
        $(".btn-gg").show();
        $(".btn-ios").hide();
      }
      if (DeviceInfo.isIos()) {
        $(".btn-ios").show();
        $(".btn-gg").hide();
      }
    },
    msg(text) {
      $("#pop-div0 p").html(text);
      $("#pop-div0").bPopup();
    },
    // 获取奖励记录
    getRewardInfo() {
      const params = {
        ...apiLoginParams(Efun.userId, Efun.loginSign, Efun.loginTimestamp),
      };

      $.ajax({
        url: "https://efe-activity.efun.com/common/public/getRewardInfo",
        data: params,
        success: function (res) {
          res = typeof res === "string" ? JSON.parse(res) : res
          if (res.code === "1000") {
            business.updateRewardInfo(res.data.afterSendRewardStatus, res.data.rewardRecordList) // 更新我的奖励
            business.updateRewardBtn(res.data.rewardRecordList) // 更新兑换按钮状态
            return
          } else {
            business.msg(res.message);
          }
        },
      });
    },
    // 更新奖励记录
    updateRewardInfo(statusList, rewardList) {
      if (!rewardList || rewardList.length === 0) return;

      let table = "";
      if (business.getRewardTimeIsNotStart) {
        rewardList.forEach((item, index) => {
          table += `
          <tr>
            <td width="40%">${item.title}</td>
            <td width="60%">
              <div class="record-state">
                <span class="state">已激活</span>
              </div>
            </td>
          </tr>`;
        });
      } else {
        rewardList.forEach((item, index) => {
          if (statusList[item.rewardCodeTimesId] == 1) {
            business.getAfterSendReward(item.rewardCode, item.rewardCodeTimesId)
          }
          table += `
          <tr>
            <td width="40%">${item.title}</td>
            <td width="60%">
              <div class="record-state">
                <span class="state">已激活</span>
                <a class="btn-copy" id="btn-copy${index + 1}" data-clipboard-text="${statusList[item.rewardCodeTimesId]}" style="display: none;"></a>
              </div>
            </td>
          </tr>`;
        });
      }



      $("#rewardTable").html(table);
    },
    // 复制奖励
    copyBtn(copyBtnId) {
      let clipboard = new ClipboardJS(`#${copyBtnId}`);
      clipboard.on("success", function (e) {
        business.msg("复制成功!");
      });
    },
    // 更新兑换按钮状态
    updateRewardBtn(rewardList) {
      const codeList = rewardList.map(item => item.rewardCode)
        .filter(item => item.startsWith("wupoint_reward_"))
        .map(item => item.substr(item.length - 1, 1))
      codeList.forEach(item => {
        $(`.btn-exchange${item}`).addClass("disabled")
      })
    },
    // 一键领取显示兑换码
    showPackageId() {
      $(".btn-copy").show()
      $(".btn-copy").each((index, dom) => {
        let packageId = $(dom).attr("data-clipboard-text")
        if (!packageId) {
          $(dom).prev().text("活动结束后于官方粉丝页公布")
          $(dom).hide()
        } else {
          $(dom).prev().text(packageId)
        }
      })
    },
    // 答题接口
    answerQuestion() {
      const params = {
        ...apiLoginParams(Efun.userId, Efun.loginSign, Efun.loginTimestamp),
        answer: business.totalOption.join(","),
      };

      $.ajax({
        url: "https://efe-activity.efun.com/smtl2/pre2/answerQuestion",
        data: params,
        success: function (res) {
          res = typeof res === "string" ? JSON.parse(res) : res
          if (res.code === "1000") {
            if (res.data.section > 0) {
              business.getReward(res.data.section)
            }
            return
          } else {
            business.msg(res.message);
          }
        },
      });
    },
    // 答题后领奖接口
    getReward(section) {
      const params = {
        ...apiLoginParams(Efun.userId, Efun.loginSign, Efun.loginTimestamp),
        rewardCode: `answer_${section}`,
      };

      $.ajax({
        url: `https://efe-activity.efun.com/common/public/getReward`,
        data: params,
        success: function (res) {
          res = typeof res === "string" ? JSON.parse(res) : res
          if (res.code === "1000") {
            business.getActivityInfo() // 更新页面奖励信息
            return
          } else {
            business.msg(res.message);
          }
        },
      });
    },
    // 获取兑换码参数接口
    getAfterSendReward(rewardCode, rewardCodeTimesId) {
      const params = {
        ...apiLoginParams(Efun.userId, Efun.loginSign, Efun.loginTimestamp),
        rewardCode,
        rewardCodeTimesId,
      };

      $.ajax({
        url: `https://efe-activity.efun.com/common/public/getAfterSendReward`,
        data: params,
        async: false, // 同步执行
        success: function (res) {
          res = typeof res === "string" ? JSON.parse(res) : res
          if (res.code === "1000") {
            business.getActivityInfo() // 更新页面奖励信息
            return
          } else {
            // business.msg(res.message);
          }
        },
      });
    },
    // 初始化留言
    initMsg() {
      business.getMsgList()
      business.updateMsgSwiper()
      // 每10分钟更新一次留言
      setInterval(() => {
        business.getMsgList()
      }, 600000);
    },
    // 获取留言接口
    getMsgList() {
      const params = {
        ...apiBasicParams(),
        currentPage: 0,
        pageSize: 50,
      };

      $.ajax({
        url: "https://efe-activity.efun.com/smtl2/pre2/getMsgList",
        data: params,
        async: false, // 同步执行
        success: function (res) {
          res = typeof res === "string" ? JSON.parse(res) : res
          if (res.code === "1000") {
            business.newMsgList = res.data.rows.map(item => item.address)
            return
          } else {
            business.msg(res.message);
          }
        },
      });
    },
    // 更新轮播留言
    updateMsgSwiper() {
      if (business.newMsgList.length < 20) {
        business.newMsgList.push(...business.msgList)
      }
      const msgList = business.newMsgList
      // 将msgList中的留言全部展示到留言墙
      let i = 0
      business.myInt = setInterval(() => {
        if (i == msgList.length) {
          // 展示完毕，更新留言
          clearInterval(business.myInt)
          business.updateMsgSwiper()
          return
        }
        let num = 0
        while (!num) {
          num = business.checkChannel()
        }
        $("<p></p>") //创建span
          .html(msgList[i]) //设置内容
          .css("color", `${business.randomColor()}`)
          .css("left", `${$('.msg').width()}px`)
          .css("font-size", `${business.randomSize()}rem`)
          .animate({ //添加动画
              marginLeft: -$(".msg").width() - 1000 // 需要使文字完全滚动出屏幕
            }, business.swiperTime, 'linear',
            function () {
              //到了终点，需要删除
              $(this).remove();
            })
          .appendTo(`.track${num}`);
        i++
      }, 1000);
    },
    // 检查留言轨道
    checkChannel() {
      let num = Math.floor(Math.random() * 9) + 1
      let $track = $(`.track${num}`)
      // 该轨道内无元素
      if ($track.children().length == 0) {
        return num
      }
      let lastWidth = $track.children("p").last()[0].getBoundingClientRect().width
      let lastLeft = Math.abs($track.children("p").last().css("margin-left").replace("px", ""))
      // 检查该轨道内最后一个p元素是否已经完全显示
      if (lastLeft > lastWidth) {
        return num
      } else {
        return 0
      }
    },
    // 留言接口
    leaveMsg() {
      const message = $(".input-data").val();
      if (!message) {
        business.msg("请输入留言")
        return
      }
      if (message.length > 20) {
        business.msg("请留言限制在20字以内")
        return
      }

      const params = {
        ...apiLoginParams(Efun.userId, Efun.loginSign, Efun.loginTimestamp),
        msg: message,
      };

      $.ajax({
        url: "https://efe-activity.efun.com/smtl2/pre2/leaveMsg",
        contentType: "application/json",
        type: "POST",
        data: JSON.stringify(params),
        success: function (res) {
          res = typeof res === "string" ? JSON.parse(res) : res
          if (res.code === "1000") {
            business.msg("留言成功！");
            business.getActivityInfo()
            // 更新留言
            business.newMsgList.unshift(message)
            clearInterval(business.myInt)
            business.updateMsgSwiper()
            $(".input-data").val("")
            return
          } else {
            business.msg(res.message);
          }
        },
      });
    },
    // 获取任务状态接口
    getActivityInfo() {
      const params = {
        ...apiLoginParams(Efun.userId, Efun.loginSign, Efun.loginTimestamp),
      };

      $.ajax({
        url: "https://efe-activity.efun.com/smtl2/pre2/getActivityInfo",
        data: params,
        success: function (res) {
          res = typeof res === "string" ? JSON.parse(res) : res
          if (res.code === "1000") {
            business.updateActivityInfo(res.data)
            business.todayShareNum = res.data.todayShareNum
            return
          } else {
            business.msg(res.message);
          }
        },
      });
    },
    // 根据任务状态调整页面显示
    updateActivityInfo(data) {
      const {
        answerSection,
        restPoint,
        todayShareNum,
        isHadAnswerQuestion,
        isHadLeaveMsg,
        inviteNum,
        isHadTeam
      } = data
      // 寻参救阿紫活动
      if (+answerSection > 0) {
        $(`.question-box1`).hide()
        $(`.question-box4`).show()
        $(".question-box .text").hide()
        $(".question-box .question").hide()
        $(".question-box .btn").hide()
        $(`.result-${data.answerSection}`).show()
      }
      // 总武点
      $("#total-num").html(restPoint)
      // 任务栏
      if (todayShareNum > 0) {
        $("#task-num1").html(2)
      }
      if (isHadAnswerQuestion) {
        $("#task-num2").html(10)
      }
      if (isHadLeaveMsg) {
        $("#task-num3").html(10)
        $(".btn-msg").addClass("disabled")
      }
      if (inviteNum > 0 && inviteNum < 5) {
        $("#task-num4").html(inviteNum * 5)
      }
      if (isHadTeam) {
        $("#task-num5").html(10)
      }
    },
    // 获取兑换奖励配置
    getRewardConfig() {
      const params = {
        ...apiBasicParams(),
        isNeedGetParentAndSon: true,
        pid: rewardConfigPid,
      };

      $.ajax({
        url: "https://efe-activity.efun.com/common/public/getRewardConfig",
        data: params,
        success: function (res) {
          res = typeof res === "string" ? JSON.parse(res) : res
          if (res.code === "1000") {

            return
          } else {
            business.msg(res.message);
          }
        },
      });
    },
    // 兑换大理集市奖励
    getWuPointReward() {
      const params = {
        ...apiLoginParams(Efun.userId, Efun.loginSign, Efun.loginTimestamp),
        rewardCode: `wupoint_reward_${business.rewardIndex+1}`,
      };

      $.ajax({
        url: `https://efe-activity.efun.com/common/public/getReward`,
        data: params,
        success: function (res) {
          res = typeof res === "string" ? JSON.parse(res) : res
          if (res.code === "1000") {
            business.msg("兑换成功！");
            business.getActivityInfo()
            business.getRewardInfo()
            return
          } else {
            business.msg(res.message);
          }
        },
      });
    },
    // 获取领奖时间
    getActivityConfigFromGraphql() {
      const query = {
        query: apiBasicParams(),
      };
      const data = {
        operationName: "activityInfo",
        query: `query activityInfo($query: BaseParamsDTO!) {
              activityMsgConfig(query: $query) {
                  isRewardNotStart{
                  flag
                  }
                  isRewardEnd{
                  flag
                  }
              }
  }
  `,
        variables: query,
      };
      $.ajax({
        url: apiUrl.graphql,
        contentType: "application/json",
        type: "POST",
        async: false, // 同步执行
        data: JSON.stringify(data),
        success: function (res) {
          const {
            data
          } = res;
          const {
            activityMsgConfig: {
              isRewardNotStart: {
                flag: isRewardTimeNotStart
              },
              isRewardEnd: {
                flag: isTimeRewardEnd
              }
            },
          } = data;
          business.getRewardTimeIsNotStart = isRewardTimeNotStart;
          business.getRewardRTimeIsEnd = isTimeRewardEnd;
        },
      });
    },
    // 检查开服时间
    getRewardTimeCheckState() {
      if (business.getRewardTimeIsNotStart) {
        business.msg("目前还没到领奖时间"); //未开启
        return false;
      }
      if (business.getRewardRTimeIsEnd) {
        business.msg("领奖时间已结束"); //已结束
        return false;
      }
      return true;
    },
    //随机生成颜色
    randomColor() {
      const r = parseInt(Math.random() * 256);
      const g = parseInt(Math.random() * 256);
      const b = parseInt(Math.random() * 256);
      return 'rgb(' + r + ',' + g + ',' + b + ')';
    },
    // 随机生成字体
    randomSize() {
      return Math.random() * (0.4 - 0.26) + 0.26
    },
    // fb分享
    fbShare: () => {
      if (business.todayShareNum > 0) {
        business.fbShareLink()
      } else if (business.todayShareNum == 0 && !business.getRewardTimeIsNotStart) {
        business.fbShareLink()
      } else {
        const params = {
          ...apiLoginParams(Efun.userId, Efun.loginSign, Efun.loginTimestamp),
        };

        $.ajax({
          url: "https://efe-activity.efun.com/common/public/share",
          data: params,
          success: function (res) {
            res = typeof res === "string" ? JSON.parse(res) : res
            if (res.code === "1000") {
              business.getActivityInfo()
              business.fbShareLink()
              return
            } else {
              business.msg(res.message);
            }
          },
        });
      }
    },
    fbShareLink() {
      const shareUrl =
        "https://tlbb2.efunen.com/event/pre2/index.html";
      location.href =
        "//www.facebook.com/dialog/share?app_id=" +
        fbAppId +
        "&href=" +
        encodeURIComponent(shareUrl) +
        "&redirect_uri=" +
        encodeURIComponent(redirectUrl);
    },
    isLogin(isNeedGoToLogin) {
      const isLogin =
        getCookie("userId") &&
        getCookie("loginSign") &&
        getCookie("loginTimestamp");
      if (isNeedGoToLogin && !isLogin) {
        Efun.gotoLogin();
        return false;
      }
      return isLogin;
    },
  };
  window.business = business;
  business.init();
});